import type React from "react";
import { useMemo, useState } from "react";

interface SourceDocument {
	id: string;
	title: string;
	contentPath?: string;
}

interface UseSourcesSelectionOptions {
	documents: SourceDocument[];
	selectedSources: Set<string>;
}

interface UseSourcesSelectionReturn {
	searchQuery: string;
	setSearchQuery: React.Dispatch<React.SetStateAction<string>>;
	filteredDocuments: SourceDocument[];
	allSelected: boolean;
}

export const useSourcesSelection = ({
	documents,
	selectedSources,
}: UseSourcesSelectionOptions): UseSourcesSelectionReturn => {
	const [searchQuery, setSearchQuery] = useState("");

	const filteredDocuments = useMemo(() => {
		return documents.filter(
			(document) =>
				document.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
				document.contentPath?.toLowerCase().includes(searchQuery.toLowerCase()),
		);
	}, [documents, searchQuery]);

	const allSelected = documents.length > 0 && selectedSources.size === documents.length;

	return {
		searchQuery,
		setSearchQuery,
		filteredDocuments,
		allSelected,
	};
};

export default useSourcesSelection;
